import React from "react";
import moment from "moment";
import {
  Divider,
  Button,
  Dropdown,
  IconButton,
  Popover,
  Whisper,
  Input,
  SelectPicker,
  DatePicker,
} from "rsuite";
import styles from "./VendorsBlock.module.css";
import {
  formatDate,
  isAddVendorButtonAvaliable,
  isPlacePOButtonAllowed,
} from "../../../../helperFunctions";

import { IoIosMore } from "react-icons/io";
import { useEffect, useState, useRef } from "react";
import { useChooseVendorsModal } from "./Components/ChooseVendorsModal/useChooseVendorsModal";
import ChooseVendorsModal from "./Components/ChooseVendorsModal/ChooseVendorsModal";
import PreviewEmailModal from "./Components/PreviewEmailModal/PreviewEmailModal";
import { useVendorsBlock } from "./useVendorsBlock";
import { DeleteIcon } from "../ItemsBlock/Components/Item/Item";
import { usePurchaseOrders } from "../../usePurchaseOrders";
import api from "../../../../api";
import ApproveVendorModal from "./Components/ApproveVendorModal/ApproveVendorModal";
import { useApproveVendorModal } from "./Components/ApproveVendorModal/useApproveVendorModal";
import { usePreviewEmailModal } from "./Components/PreviewEmailModal/usePreviewEmailModal";
import { useConfirmationModal } from "../../../../Components/ConfirmationModal/useConfirmationModal";
import { IoDocumentTextOutline } from "react-icons/io5";
import { currencyOptions } from "../../../Settings/Data/lists";
import FileUploaderModal from "./Components/FileUploaderModal/FileUploaderModal";
import { useFileUploaderModal } from "./Components/FileUploaderModal/useFileUploaderModal";
import ImportPricesPreviewModal from "../ImportPricesPreviewModal/ImportPricesPreviewModal";
import { useImportPricesPreviewModal } from "../ImportPricesPreviewModal/useImportPricesPreviewModal";
import InvoiceIconFile from "../../../../Components/Icons/invoice.png";
import {
  DEFAULT_CURRENCY,
  parseOrderAmount,
  formatOrderAmount,
} from "../../orderAmount";

// Calls `onOutside` when a mousedown lands outside `ref` while `active`. Clicks
// inside rsuite portal popups (the currency SelectPicker menu renders detached
// from the ref) are NOT treated as "outside", so picking a currency won't close
// the editor.
function useClickOutside(ref, active, onOutside) {
  const cb = useRef(onOutside);
  cb.current = onOutside;
  useEffect(() => {
    if (!active) return;
    const handler = (e) => {
      if (ref.current && ref.current.contains(e.target)) return;
      if (e.target.closest && e.target.closest(".rs-picker-menu, .rs-popup"))
        return;
      cb.current();
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, [ref, active]);
}

function VendorsBlock({ purchaseOrderId, vendors, countFormChanges2 }) {
  const { showChooseVendorsModal } = useChooseVendorsModal();
  const {
    deleteVendor,
    inquire,
    approveVendor,
    withdrawVendorApproval,
    changeVendorOrderAmount,
    changeVendorOrderNote,
    changeVendorCrossRate,
    changeVendorDeliveryDate,
    changeVendorIncludeInComparison,
    attachQuotationFiles,
  } = usePurchaseOrders();
  const { form, generating } = usePurchaseOrders();
  const { showApproveVendorModal } = useApproveVendorModal();
  const { showConfirmationModal } = useConfirmationModal();
  const { showPreviewEmailModal } = usePreviewEmailModal();
  const { showFileUploaderModal } = useFileUploaderModal();

  const { loading, countFormChanges } = usePurchaseOrders();

  const ChooseVendor = () => {
    const isChoosed = showChooseVendorsModal();
    let { set, get } = usePurchaseOrders();
    if (isChoosed) set({ countFormChanges: countFormChanges - 1 });

    if (countFormChanges) {
      const { countFormChanges } = get();
      console.log(countFormChanges);
    }
  };

  const addVendorButton = (
    <>
      <Button
        onClick={ChooseVendor}
        color="blue"
        appearance="primary"
        style={{ width: 100 }}
      >
        Add vendor
      </Button>
    </>
  );

  const showAddVendorButton = isAddVendorButtonAvaliable(form.status);

  return (
    <>
      <div className={styles.container}>
        <Divider />
        <div className={styles.header}>
          <div className={styles.title}>Vendors</div>
        </div>
        {/* <div className={styles.titles}>
          <div>Vendor Name</div>
 
          <div>Attached Files</div>
          <div>Action</div>
        </div> */}
        <div className={styles.vendors_container}>
          {vendors.length != 0 &&
            vendors.map((vendor) => (
              <>
                <Vendor
                  vendorData={vendor}
                  poStatus={form?.status}
                  //poId={form?._id}
                  // inquredStatus={vendor?.status}
                  // name={vendor?.name}
                  // dateInquired={vendor?.dateInquired}
                  // dateApproved={vendor?.dateApproved}
                  // datePlacedPO={vendor?.datePlacedPO}
                  // dateCanceledInquiry={vendor?.dateCanceledInquiry}
                  // dateWithdrawApproval={vendor?.dateWithdrawApproval}
                  onDelete={() => {
                    deleteVendor(vendor?.vendorIndex, vendor?.id, vendor?.name);
                  }}
                  onInquire={async () => {
                    return inquire(
                      vendor?.vendorIndex,
                      vendor?.id,
                      vendor?.name,
                      "",
                    );
                  }}
                  onPreviewEmail={async () => {
                    return showPreviewEmailModal(
                      vendor?.vendorIndex,
                      vendor?.name,
                      vendor?.id,
                      form._id,
                    );
                  }}
                  onApprove={async () => {
                    return approveVendor(
                      vendor?.vendorIndex,
                      vendor?.id,
                      vendor?.name,
                    );
                  }}
                  onPlacePO={() => {
                    ConfirmationModalNew(
                      () => {
                        showApproveVendorModal(
                          vendor?.vendorIndex,
                          vendor?.id,
                          form._id,
                          vendor?.name,
                          form.items,
                        );
                      },
                      countFormChanges,
                      showConfirmationModal,
                    );
                  }}
                  onWithdrawVendorApproval={async () => {
                    return withdrawVendorApproval(
                      vendor?.vendorIndex,
                      vendor?.id,
                      vendor?.name,
                    );
                  }}
                  // onApprove={() => {
                  // 	showApproveVendorModal(vendor?.id, form._id, vendor?.name, form.items);
                  // }}
                  // onApprove={()=>{approveVendor(vendor?.id,vendor?.name)}}
                  // loading={loading}
                  files={vendor?.files}
                  changeVendorOrderAmount={changeVendorOrderAmount}
                  changeVendorOrderNote={changeVendorOrderNote}
                  changeVendorCrossRate={changeVendorCrossRate}
                  changeVendorDeliveryDate={changeVendorDeliveryDate}
                  changeVendorIncludeInComparison={
                    changeVendorIncludeInComparison
                  }
                  onAttachQuotationFile={async () => {
                    showFileUploaderModal(
                      purchaseOrderId,
                      vendor?.vendorIndex,
                      vendor?.id,
                      vendor?.name,
                    );
                  }}
                />
              </>
            ))}

          <div style={{ height: "10px" }}></div>
          {showAddVendorButton && addVendorButton}
        </div>
      </div>
      <ApproveVendorModal />

      <ChooseVendorsModal purchaseOrderId={purchaseOrderId} />
      <PreviewEmailModal />
      <FileUploaderModal />
      <ImportPricesPreviewModal />
    </>
  );
}

export default VendorsBlock;

const ConfirmationModalNew = (fn, countFormChanges, showConfirmationModal) => {
  if (countFormChanges > 2) {
    showConfirmationModal("vendorapprove", fn);
  } else {
    fn();
  }
};

const Vendor = ({
  vendorData,
  poStatus,
  //poId,
  //inquredStatus,
  // name,
  // dateInquired,
  // dateApproved,
  // datePlacedPO,
  // dateWithdrawApproval,
  // dateCanceledInquiry,
  onInquire,
  onDelete,
  onApprove,
  onPlacePO,
  //files,
  onPreviewEmail,
  onWithdrawVendorApproval,
  changeVendorOrderAmount,
  changeVendorOrderNote,
  changeVendorCrossRate,
  changeVendorDeliveryDate,
  changeVendorIncludeInComparison,
  onAttachQuotationFile,
}) => {
  const [loading, setLoading] = useState(false);

  const handleInquire = async () => {
    setLoading(true);
    await onInquire();
    setLoading(false);
  };

  const handleApprove = async () => {
    setLoading(true);
    await onApprove();
    setLoading(false);
  };

  const inquredStatus = vendorData?.status;
  const vendorId = vendorData?._id;
  const quotationFile = vendorData?.quotationFiles
    ? vendorData?.quotationFiles[0]
    : null;

  // Whether this vendor currently shows in the price comparison. 3-state
  // includeInComparison: true = force include, false = force exclude,
  // undefined = default (included when a quotation file exists). Must match
  // the same rule in PriceComparisonBlock.
  const isIncludedInComparison =
    vendorData?.includeInComparison === true
      ? true
      : vendorData?.includeInComparison === false
        ? false
        : !!(
            vendorData?.quotationFiles && vendorData.quotationFiles.length > 0
          );

  // The vendor's attached quotation can be re-parsed without re-uploading.
  const isExcelQuote = (name = "") => /\.(xlsx|xls)$/i.test(name);
  const excelQuotation =
    quotationFile && isExcelQuote(quotationFile?.fileName || quotationFile?.url)
      ? quotationFile
      : null;

  const handleParseQuotation = () => {
    if (!excelQuotation?.url) return;
    const { form } = usePurchaseOrders.getState();
    const { currency } = parseOrderAmount(vendorData?.orderAmount);
    useImportPricesPreviewModal.getState().startImport({
      purchaseOrderId: form?._id,
      vendor: {
        vendorIndex: vendorData?.vendorIndex,
        vendorId: vendorData?.id,
        vendorName: vendorData?.name,
        currency: currency || "USD",
      },
      url: excelQuotation.url,
    });
  };
  // const name={venvorData?.name}
  // const dateInquired={venvorData?.dateInquired}
  // const dateApproved={venvorData?.dateApproved}
  // const datePlacedPO={venvorData?.datePlacedPO}
  // const dateCanceledInquiry={venvorData?.dateCanceledInquiry}
  // const dateWithdrawApproval={venvorData?.dateWithdrawApproval}

  const cropURL = (url) => {
    let name = url.substring(url.lastIndexOf("/") + 1);
    if (name.length > 49) name = name.slice(0, 49) + "..";
    return name;
  };
  const {
    name,
    dateInquired,
    dateApproved,
    datePlacedPO,
    deliveryDate,
    dateCanceledInquiry,
    dateWithdrawApproval,
    files,
  } = vendorData;

  const InquireButton = (
    <>
      <Button
        loading={loading}
        onClick={handleInquire}
        color="violet"
        appearance="primary"
        style={{ width: 130 }}
      >
        Send Inquiry
      </Button>
    </>
  );

  const tooltip = <Popover>Preview email</Popover>;

  const EmailPreviewButton = (
    <>
      <Whisper
        placement="topStart"
        delayOpen={800}
        controlId="control-id-hover"
        trigger="hover"
        speaker={tooltip}
      >
        <Button
          onClick={onPreviewEmail}
          appearance="subtle"
          style={{ width: 42 }}
        >
          <IoDocumentTextOutline
            onClick={onPreviewEmail}
            style={{ width: 45 }}
          />
        </Button>
      </Whisper>
    </>
  );
  const approveTooltip = (
    <Popover>
      Click to approve the vendor and set the purchase order as ready to be
      placed by the Purchase Officer
    </Popover>
  );
  const ApproveButton = (
    <>
      <Whisper
        placement="top"
        delayOpen={800}
        controlId="control-id-hover"
        trigger="hover"
        speaker={approveTooltip}
      >
        <Button
          onClick={onApprove}
          color="green"
          appearance="primary"
          style={{ width: 130 }}
        >
          Approve
        </Button>
      </Whisper>
    </>
  );
  const placePOTooltip = (
    <Popover>
      Click to enter purchase order details and send PO to the vendor
    </Popover>
  );
  const PlacePOButton = (
    <>
      {" "}
      <Whisper
        placement="top"
        delayOpen={800}
        controlId="control-id-hover"
        trigger="hover"
        speaker={placePOTooltip}
      >
        <Button
          disabled={!isPlacePOButtonAllowed()}
          onClick={onPlacePO}
          color="green"
          appearance="primary"
          style={{ width: 130 }}
        >
          Place PO
        </Button>
      </Whisper>
    </>
  );

  const OtherActions = (
    <>
      <div
        style={{
          width: "50px",
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Dropdown
          placement="bottomStart"
          renderToggle={(props, ref) => (
            <IconButton
              {...props}
              ref={ref}
              icon={<IoIosMore style={{ height: 20, width: 20 }} />}
              appearance="subtle"
              style={{
                width: "auto",
                height: 37,
                marginLeft: 0,
                display: "flex",
                alignItems: "center",
                padding: "0 12px",
              }}
            ></IconButton>
          )}
        >
          <Dropdown.Item onClick={onAttachQuotationFile}>
            <div style={{ marginLeft: 10, width: 140 }}>Attach Quotation</div>
          </Dropdown.Item>
          {excelQuotation && (
            <Dropdown.Item onClick={handleParseQuotation}>
              <div style={{ marginLeft: 10, width: 140 }}>Parse Quotation</div>
            </Dropdown.Item>
          )}
          <Dropdown.Item
            onClick={() =>
              changeVendorIncludeInComparison(
                vendorData?.vendorIndex,
                vendorData?.id,
                !isIncludedInComparison,
              )
            }
          >
            <div style={{ marginLeft: 10, width: 180 }}>
              {isIncludedInComparison
                ? "Remove from comparison"
                : "Include for comparison"}
            </div>
          </Dropdown.Item>
          {inquredStatus === "not inquired" && (
            <Dropdown.Item onClick={onPreviewEmail}>
              <div style={{ marginLeft: 10, width: 140 }}>Preview email</div>
            </Dropdown.Item>
          )}
          {inquredStatus == "approved" && poStatus == "vendor approved" && (
            <Dropdown.Item onClick={onWithdrawVendorApproval}>
              <div style={{ marginLeft: 10, width: 140 }}>
                Withdraw Approval
              </div>
            </Dropdown.Item>
          )}
          {inquredStatus == "po placed" &&
            poStatus == "po placed" &&
            !dateWithdrawApproval && (
              <Dropdown.Item onClick={onWithdrawVendorApproval}>
                <div style={{ marginLeft: 10, width: 140 }}>
                  Withdraw Approval
                </div>
              </Dropdown.Item>
            )}
          {inquredStatus === "not inquired" && !loading && (
            <Dropdown.Item onClick={onDelete}>
              <div style={{ marginLeft: 10, width: 140 }}>Delete vendor</div>
            </Dropdown.Item>
          )}
          {inquredStatus === "inquired" && !dateInquired && (
            <Dropdown.Item onClick={onDelete}>
              <div style={{ marginLeft: 10, width: 140 }}>Delete vendor</div>
            </Dropdown.Item>
          )}

          {files && files.length > 0 && (
            <Dropdown.Item>
              <Whisper
                trigger="click"
                placement={"top"}
                speaker={
                  <Popover style={{ width: "530px" }} title="Attached Files">
                    {files.map((file, index) => (
                      <div>
                        File {index + 1}:{" "}
                        <a key={index} href={file.url}>
                          {cropURL(file.url)}
                        </a>
                      </div>
                    ))}
                  </Popover>
                }
              >
                <div
                  style={{
                    width: "140px",
                    paddingLeft: 10,
                    fontWeight: 500,
                  }}
                >
                  View Files
                </div>
              </Whisper>
            </Dropdown.Item>
          )}
          {/* <div style={{ marginLeft: 15, width: 140 }}>View Files</div> */}
        </Dropdown>
      </div>
    </>
  );

  const InquiredText = (
    <span style={{ fontSize: 12 }}>
      {dateInquired ? (
        <>
          Inquired{" "}
          {moment.utc(dateInquired, moment.ISO_8601).format("DD/MM/YYYY")}
        </>
      ) : (
        <>Not inquired</>
      )}
    </span>
  );

  const ApprovedText = (
    <>
      <span style={{ fontSize: 12 }}>
        Approved{" "}
        {moment.utc(dateApproved, moment.ISO_8601).format("DD/MM/YYYY")}
      </span>
    </>
  );

  const [editingDeliveryDate, setEditingDeliveryDate] = useState(false);

  const handleSaveDeliveryDate = (date) => {
    setEditingDeliveryDate(false);
    changeVendorDeliveryDate(
      vendorData?.vendorIndex,
      vendorData?.id,
      date ? date.toISOString() : null,
    );
  };

  const POplacedText = (
    <>
      <div className={styles.stack_line}>
        <span style={{ fontSize: 12, fontWeight: 800 }}>
          PO placed:{" "}
          {moment.utc(datePlacedPO, moment.ISO_8601).format("DD/MM/YYYY")}
        </span>
      </div>
      <div className={styles.stack_line}>
        {editingDeliveryDate ? (
          <DatePicker
            size="sm"
            oneTap
            cleanable
            format="dd/MM/yyyy"
            placeholder="Set date"
            placement="autoVerticalStart"
            style={{ width: 130 }}
            defaultOpen
            value={deliveryDate ? new Date(deliveryDate) : null}
            onChange={handleSaveDeliveryDate}
            onClose={() => setEditingDeliveryDate(false)}
          />
        ) : (
          <div
            className={styles.delivery_date_text}
            onClick={() => {
              if (poStatus !== "archived") setEditingDeliveryDate(true);
            }}
          >
            Delivery:{" "}
            {deliveryDate
              ? moment.utc(deliveryDate, moment.ISO_8601).format("DD/MM/YYYY")
              : " - "}
          </div>
        )}
      </div>
    </>
  );
  // const withdrawTooltip = (
  //   <Popover>
  //     The approval will be withdrawn, and you will have the option to add and
  //     inquire new vendors
  //   </Popover>
  // );
  // const withdrawVendorApprovalButton = (
  //   <>
  //     <Whisper
  //       placement="top"
  //       delayOpen={800}
  //       controlId="control-id-hover"
  //       trigger="hover"
  //       speaker={withdrawTooltip}
  //     >
  //       <Button
  //         onClick={onWithdrawVendorApproval}
  //         appearance="ghost"
  //         style={{ width: 140 }}
  //       >
  //         Withdraw Approval
  //       </Button>
  //     </Whisper>
  //   </>
  // );

  const DisabledButton = <div> </div>;

  const getActionDate = () => {
    if (dateWithdrawApproval)
      return (
        <>
          <span style={{ fontSize: 12 }}>
            Withdrawn{" "}
            {moment
              .utc(dateWithdrawApproval, moment.ISO_8601)
              .format("DD/MM/YYYY")}
          </span>
        </>
      );
    if (inquredStatus == "cancelled")
      return (
        <>
          <span style={{ fontSize: 12 }}>
            Canceled{" "}
            {dateCanceledInquiry &&
              moment
                .utc(dateCanceledInquiry, moment.ISO_8601)
                .format("DD/MM/YYYY")}
          </span>
        </>
      );
    if (inquredStatus == "inquired" || inquredStatus == "rejected")
      return <>{InquiredText}</>;

    if (inquredStatus == "approved" && poStatus == "vendor approved")
      return <>{ApprovedText}</>;
    if (inquredStatus == "approved" && dateWithdrawApproval)
      return <>{ApprovedText}</>;

    if (inquredStatus == "approved" && !datePlacedPO)
      return <>{ApprovedText}</>;

    if (inquredStatus == "po placed")
      if (poStatus == "vendor approved" || poStatus == "po placed")
        return (
          <>
            {POplacedText}
            {/* {!dateWithdrawApproval && withdrawVendorApprovalButton}{" "} */}
          </>
        );
      else return <>{POplacedText}</>;
  };

  const getQuotationLink = () => {
    if (quotationFile)
      return (
        <>
          <Whisper
            trigger="hover"
            placement={"top"}
            speaker={
              <Popover>
                Quotation file
                <br />
                {quotationFile?.fileName}
              </Popover>
            }
          >
            <div>
              <a
                key={quotationFile?.fileName}
                href={quotationFile?.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  style={{
                    paddingTop: "3px",
                    width: "35px",
                    height: "35px",
                  }}
                  src={InvoiceIconFile}
                  alt="Invoice received"
                />
              </a>
            </div>
          </Whisper>
        </>
      );
    else return <div style={{ width: "35px", height: "35px" }}> </div>;
  };

  const getVendorButton = () => {
    if (dateWithdrawApproval) return DisabledButton;
    if (inquredStatus == "not inquired") return InquireButton;
    if (inquredStatus == "inquired" && !dateInquired) return InquireButton;
    if (inquredStatus == "inquired") return <>{ApproveButton}</>;

    if (inquredStatus == "approved" && poStatus == "vendor approved")
      return <>{PlacePOButton}</>;

    if (
      ["rejected", "cancelled", "approved", "po placed"].includes(inquredStatus)
    )
      return DisabledButton;
  };

  const [vendorOrderAmount, setVendorOrderAmount] = useState("");
  const [orderCurrency, setOrderCurrency] = useState(DEFAULT_CURRENCY);
  const [editingOrderAmount, setEditingOrderAmount] = useState(false);
  const orderAmountRef = useRef(null);

  // Click outside the price editor → save and close (no Save click required).
  useClickOutside(orderAmountRef, editingOrderAmount, () =>
    handleSaveOrderAmount(vendorOrderAmount, orderCurrency),
  );

  // Keep amount + currency in sync with the persisted combined string.
  useEffect(() => {
    const { amount, currency } = parseOrderAmount(vendorData?.orderAmount);
    setVendorOrderAmount(amount);
    setOrderCurrency(currency);
  }, [vendorData?.orderAmount]);

  const handleEditClickVendorOrderAmount = () => {
    if (poStatus == "archived") return;
    const { amount, currency } = parseOrderAmount(vendorData?.orderAmount);
    setVendorOrderAmount(amount);
    setOrderCurrency(currency);
    setEditingOrderAmount(true);
  };

  const handleSaveOrderAmount = async (amount, currency) => {
    const combined = formatOrderAmount(amount, currency);

    // Nothing entered — just leave edit mode without persisting.
    if (combined === "") {
      setEditingOrderAmount(false);
      return;
    }

    // Unchanged — skip the network round-trip.
    if (combined === (vendorData?.orderAmount || "")) {
      setEditingOrderAmount(false);
      return;
    }

    // What currency is the saved amount in, and did it change?
    const prevCurrency = parseOrderAmount(vendorData?.orderAmount).currency;
    const newCurrency = String(currency || DEFAULT_CURRENCY).toUpperCase();
    const currencyChanged = newCurrency !== String(prevCurrency).toUpperCase();

    setLoading(true);
    const responce = await changeVendorOrderAmount(
      vendorData?.vendorIndex,
      vendorData?.id,
      combined,
    );
    if (!responce) {
      setVendorOrderAmount("error");
    }

    setEditingOrderAmount(false);
    setLoading(false);

    // Only (re)fetch the cross rate when the PRICE is added/changed — not on
    // page load. Skip for USD (no conversion needed). Refresh the rate if the
    // currency changed or none is set yet.
    if (responce && newCurrency !== "USD") {
      if (currencyChanged || vendorData?.crossRate == null) {
        fetchAndSaveCrossRate(newCurrency);
      }
    }
  };

  // Fetch the live rate for `currency` -> USD and persist it. Called only on a
  // price add/change (and from the manual editor). No-op on failure so the
  // user can still set the rate manually.
  const fetchAndSaveCrossRate = async (currency) => {
    console.log(`[crossrate] fetching ${currency} -> USD (price changed)`);
    setFetchingRate(true);
    const rate = await api.getCrossRate(currency, "USD");
    setFetchingRate(false);
    if (rate != null) {
      console.log(`[crossrate] got 1 ${currency} = ${rate} USD -> persisting`);
      setCrossRate(rate);
      await changeVendorCrossRate(
        vendorData?.vendorIndex,
        vendorData?.id,
        Number(rate.toFixed(6)),
      );
    } else {
      console.log(
        `[crossrate] no rate for ${currency} -> USD; use manual "Set crossrate"`,
      );
    }
  };

  // ---- Cross rate -> USD ----
  const [crossRate, setCrossRate] = useState(vendorData?.crossRate ?? null);
  const [editingCrossRate, setEditingCrossRate] = useState(false);
  const [crossRateInput, setCrossRateInput] = useState("");
  const [fetchingRate, setFetchingRate] = useState(false);
  const crossRateRef = useRef(null);

  // Click outside the cross-rate editor → save and close.
  useClickOutside(crossRateRef, editingCrossRate, () =>
    handleSaveCrossRate(crossRateInput),
  );

  // Keep the displayed rate in sync with the persisted value (e.g. after a
  // save refetches the form). Does NOT fetch — fetching only happens on a
  // price add/change (see handleSaveOrderAmount) or manual "Set crossrate".
  useEffect(() => {
    setCrossRate(vendorData?.crossRate ?? null);
  }, [vendorData?.crossRate]);

  const { amount: parsedAmount, currency: parsedCurrency } = parseOrderAmount(
    vendorData?.orderAmount,
  );
  const numericAmount = parseFloat(String(parsedAmount).replace(/,/g, ""));
  const hasAmount = !isNaN(numericAmount);
  const isUsd = String(parsedCurrency).toUpperCase() === "USD";

  // USD value: amount itself if already USD, else amount * crossRate.
  const orderAmountUSD = !hasAmount
    ? null
    : isUsd
      ? numericAmount
      : crossRate
        ? numericAmount * crossRate
        : null;

  const fmtUSD = (v) =>
    v == null
      ? null
      : v.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });

  // Open the cross-rate editor; try to auto-fetch the live rate first.
  const handleSetCrossRate = async () => {
    if (poStatus == "archived") return;
    setEditingCrossRate(true);
    setCrossRateInput(crossRate != null ? String(crossRate) : "");
    if (crossRate == null && !isUsd && parsedCurrency) {
      setFetchingRate(true);
      const rate = await api.getCrossRate(parsedCurrency, "USD");
      setFetchingRate(false);
      if (rate != null) setCrossRateInput(String(Number(rate.toFixed(6))));
    }
  };

  const handleSaveCrossRate = async (value) => {
    const num = value === "" || value == null ? null : Number(value);
    setEditingCrossRate(false);
    if (num !== null && isNaN(num)) return;
    if ((num ?? null) === (vendorData?.crossRate ?? null)) return;
    setLoading(true);
    await changeVendorCrossRate(vendorData?.vendorIndex, vendorData?.id, num);
    setLoading(false);
  };

  // ---- Order note ----
  const [orderNote, setOrderNote] = useState(vendorData?.orderNote || "");
  const [noteExpanded, setNoteExpanded] = useState(false);

  useEffect(() => {
    setOrderNote(vendorData?.orderNote || "");
  }, [vendorData?.orderNote]);

  const readonlyNote = poStatus == "archived";

  const toggleNote = () => {
    if (noteExpanded) {
      setNoteExpanded(false);
      return;
    }
    setOrderNote(vendorData?.orderNote || "");
    setNoteExpanded(true);
  };

  const closeNote = () => {
    setOrderNote(vendorData?.orderNote || ""); // discard unsaved edits
    setNoteExpanded(false);
  };

  const handleSaveOrderNote = async () => {
    setNoteExpanded(false);
    if ((orderNote || "") === (vendorData?.orderNote || "")) return;
    setLoading(true);
    await changeVendorOrderNote(
      vendorData?.vendorIndex,
      vendorData?.id,
      orderNote,
    );
    setLoading(false);
  };

  const OrderAmount = (
    <>
      {editingOrderAmount ? (
        <div className={styles.order_amount_edit} ref={orderAmountRef}>
          <Input
            className={styles.order_amount_input}
            value={vendorOrderAmount}
            placeholder="Price"
            size="sm"
            style={{ width: 100 }}
            onChange={(value) =>
              // Allow digits, one decimal point and minus only — but let the
              // user type a float freely (rsuite InputNumber ate decimals).
              setVendorOrderAmount(value.replace(/[^0-9.\-]/g, ""))
            }
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSaveOrderAmount(vendorOrderAmount, orderCurrency);
              }
            }}
            autoFocus
          />
          <SelectPicker
            className={styles.order_amount_currency}
            data={currencyOptions}
            value={orderCurrency}
            cleanable={false}
            searchable={false}
            size="sm"
            style={{ width: 70 }}
            onChange={(value) => setOrderCurrency(value || DEFAULT_CURRENCY)}
          />
          <Button
            size="sm"
            appearance="primary"
            color="blue"
            onClick={() =>
              handleSaveOrderAmount(vendorOrderAmount, orderCurrency)
            }
          >
            Save
          </Button>
        </div>
      ) : (
        <span
          className={styles.order_price}
          onClick={handleEditClickVendorOrderAmount}
        >
          Price:{" "}
          <span
            className={styles.order_amount_text}
            style={{
              fontWeight: inquredStatus === "po placed" ? 700 : 400,
            }}
          >
            {vendorOrderAmount && vendorOrderAmount !== "error"
              ? `${vendorOrderAmount} ${orderCurrency}`
              : vendorOrderAmount === "error"
                ? "error"
                : " - "}
          </span>
        </span>
      )}
    </>
  );

  // No USD/cross-rate UI when the price is already in USD, or when there is
  // no amount yet — it only makes sense for a non-USD amount.
  const showCrossRate = hasAmount && !isUsd;

  const OrderAmountUSD = !showCrossRate ? null : (
    <>
      {editingCrossRate ? (
        <div className={styles.order_amount_edit} ref={crossRateRef}>
          <Input
            className={styles.order_amount_input}
            value={crossRateInput}
            placeholder={fetchingRate ? "Fetching…" : "Cross rate"}
            size="sm"
            style={{ width: 110 }}
            onChange={(value) =>
              setCrossRateInput(value.replace(/[^0-9.\-]/g, ""))
            }
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                handleSaveCrossRate(crossRateInput);
              }
            }}
            autoFocus
          />
          <span style={{ fontSize: 11, color: "#94a0a6" }}>
            {parsedCurrency}→USD
          </span>
          <Button
            size="sm"
            appearance="primary"
            color="blue"
            loading={fetchingRate}
            onClick={() => handleSaveCrossRate(crossRateInput)}
          >
            Save
          </Button>
        </div>
      ) : (
        <span className={styles.order_amount_usd}>
          {orderAmountUSD != null ? (
            <span>
              <span
                style={{
                  fontWeight: inquredStatus === "po placed" ? 700 : 400,
                }}
                className={styles.order_amount_text}
              >
                {fmtUSD(orderAmountUSD)} USD
              </span>
              <span
                className={styles.cross_rate_edit_link}
                onClick={handleSetCrossRate}
              >
                {" "}
                ({crossRate})
              </span>
            </span>
          ) : (
            <span
              className={styles.cross_rate_link}
              onClick={handleSetCrossRate}
            >
              Set crossrate
            </span>
          )}
        </span>
      )}
    </>
  );

  // Inline trigger — click to expand the note editor below the card.
  const OrderNote = (
    <span
      className={styles.order_note_text}
      title={vendorData?.orderNote || ""}
      onClick={toggleNote}
    >
      <span style={{ fontSize: 12 }}>
        Note: {vendorData?.orderNote ? vendorData.orderNote : " - "}
      </span>
    </span>
  );

  // Expandable note panel — rendered full-width inside the card so the vendor
  // box grows while open, then collapses on Save/Close.
  const OrderNotePanel = noteExpanded ? (
    <div className={styles.note_panel}>
      <Input
        className={styles.note_textarea}
        as="textarea"
        rows={6}
        value={orderNote}
        placeholder={readonlyNote ? "No note" : "Enter order note"}
        readOnly={readonlyNote}
        onChange={(value) => setOrderNote(value)}
        autoFocus
      />
      <div className={styles.note_panel_actions}>
        <Button size="sm" appearance="subtle" onClick={closeNote}>
          {readonlyNote ? "Close" : "Cancel"}
        </Button>
        {!readonlyNote && (
          <Button size="sm" appearance="primary" onClick={handleSaveOrderNote}>
            Save
          </Button>
        )}
      </div>
    </div>
  ) : null;

  return (
    <>
      <div
        className={`${styles.vendor_card} ${
          inquredStatus === "po placed" ? styles.po_placed : ""
        }`}
      >
        <div className={styles.vendor_container}>
          <strong>{name}</strong>

          <div className={styles.order_amount_wrap}>
            <div
              className={`${styles.order_amount_row} ${styles.stack_line} ${
                editingOrderAmount || editingCrossRate
                  ? styles.order_amount_row_editing
                  : ""
              }`}
            >
              {/* While editing one field, hide the other for a clean, roomy
                  editor (price editor hides USD; cross-rate editor hides price). */}
              {!editingCrossRate && OrderAmount}
              {!editingOrderAmount && OrderAmountUSD}
            </div>
            <div className={styles.stack_line}>{OrderNote}</div>
          </div>

          <div className={styles.action_date_wrap}>{getActionDate()}</div>
          {getQuotationLink()}
          {getVendorButton()}
          {OtherActions}
        </div>

        {OrderNotePanel}
      </div>
    </>
  );
};
